import React, { useEffect, useState } from "react";
import { Card, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { motion } from "framer-motion";
import { useRouter } from "next/navigation";
import imagePlaceholder from "../../../public/images/imagePlaceholder.png";
import styles from "../../styles/CatalogueProductCard.module.css";
import { LoadingCard } from "../../components";
import Link from "next/link";
import { marketplaceCdn } from "../../utility/env";
import { replaceSpecialCharacters } from "../../utility/Images/utils";
import { model_visit } from "../../UserEvents/UserEvents";
import { useUserStore } from "../../store/User";
import Image from "next/image";
import { trackModelVisit } from "../../utility/UserEvents";

interface productProp {
  recomended?: boolean;
  loading?: Boolean;
  title: string;
  infoForUrl?: string;
  modelId: number;
  imageUrl?: string;
  category?: string;
  isLoading?: boolean;
  brandName?: string;
}

interface heightType {
  height: {
    delay: number;
    duration: number;
  };
}
const ProductCard: React.FC<productProp> = ({
  recomended,
  loading,
  title,
  infoForUrl,
  modelId,
  imageUrl,
  category,
  isLoading,
  brandName,
}) => {
  const router = useRouter();
  const { user, token } = useUserStore((state: any) => state);

  return (
    <>
      <Col
        className="mt-3  d-flex justify-content-center flex-wrap p-0 "
        xl="3"
        lg="4"
        md="4"
        sm="4"
        xs="6"
      >
        <Link
          onClick={() => {
            trackModelVisit(
              modelId,
              user?.uuid,
              category,
              title,
              `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}specs/${category}/${replaceSpecialCharacters(title.replaceAll(" ", "-").replaceAll("/", "").replaceAll('"', "").replaceAll("--", ""))}-${modelId}`
            );
          }}
          href={
            infoForUrl
              ? `/specs/${category}/${replaceSpecialCharacters(
                  infoForUrl
                    .replaceAll(" ", "-")
                    .replaceAll("/", "-")
                    .replaceAll('"', "")
                )}-${modelId}`
              : `/specs/${category}/${replaceSpecialCharacters(
                  title
                    .replaceAll(" ", "-")
                    .replaceAll("/", "-")
                    .replaceAll('"', "")
                )}-${modelId}`
          }
        >
          <Card
            className={` ${recomended ? "" : " "} cursor-pointer  ${
              styles.specsCard
            } gap-3 `}
          >
            <div
              style={{
                position: "relative",

                height: "128px",
              }}
            >
              <Image
                width={148}
                height={128}
                className={`p-0 w-100 ${styles.cardImg}`}
                src={`${marketplaceCdn}/${imageUrl}`}
                alt={`Image for ${title}`}
                // onError={(e) => {
                //   const imgElement = e.target as HTMLImageElement;
                //   imgElement.src = `${imagePlaceholder.src}`;
                // }}
              />
            </div>

            <Card.Body className="p-0" style={{ paddingTop: "0px" }}>
              <Card.Title className={`mb-2  pt-2 w-100 ${styles.title}`}>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip">{title}</Tooltip>}
                >
                  <p className={` mb-0 text-center   ${styles.title_content}`}>
                    {brandName + " " + title}
                  </p>
                </OverlayTrigger>
              </Card.Title>
            </Card.Body>
          </Card>
        </Link>
      </Col>
    </>
  );
};

export default ProductCard;
